var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDefaultIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.4811 11.4503L20.3833 11.4503C20.1523 11.4503 19.9651 11.2631 19.9651 11.0322L19.9651 4.39389L20.5779 4.39389L26.4811 10.73L26.4811 11.4503ZM26.4811 12.8442L20.3833 12.8442C19.3825 12.8442 18.5712 12.0329 18.5712 11.0322L18.5712 4.39389L9.89389 4.39389L9.89389 27.9561L26.4811 27.9561L26.4811 12.8442ZM27.875 28.2349C27.875 28.8508 27.3757 29.35 26.7599 29.35L9.61511 29.35C8.99926 29.35 8.5 28.8508 8.5 28.2349L8.5 4.11512C8.5 3.49926 8.99926 3.00001 9.61511 3.00001L20.6992 3.00001C21.0086 3.00001 21.3041 3.12858 21.5151 3.35498L27.5758 9.86013C27.7681 10.0665 27.875 10.3382 27.875 10.6203L27.875 28.2349ZM19 19L12 19L12 17.5L19 17.5L19 19ZM12 23L19 23L19 21.5L12 21.5L12 23Z",
    fill: "#1A1B1D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultIcon);
export default __webpack_public_path__ + "static/media/default-icon.514d307b58e2cbfa9ed0713124a03b98.svg";
export { ForwardRef as ReactComponent };